document.querySelectorAll('.kontaktformular').forEach((form) => {
	const submitButton = form.querySelector('button[type="submit"]');
	const statusField = form.querySelector('.form-status');

	if (!submitButton || !statusField) return;

	form.addEventListener('submit', async (event) => {
		event.preventDefault();

		statusField.hidden = true;
		statusField.textContent = '';
		submitButton.disabled = true;
		form.setAttribute('aria-busy', 'true');

		try {
			const response = await fetch(form.action, {
				method: 'POST',
				body: new FormData(form),
				headers: {
					Accept: 'application/json',
				},
			});
			const result = await response.json();

			if (!response.ok || result.success !== true) {
				throw new Error('Mailversand fehlgeschlagen');
			}

			statusField.textContent = 'Danke, ich melde mich';
		} catch (error) {
			statusField.textContent = 'Fehler, bitte später versuchen';
		} finally {
			statusField.hidden = false;
			submitButton.disabled = false;
			form.removeAttribute('aria-busy');

			requestAnimationFrame(() => {
				statusField.scrollIntoView({
					behavior: 'smooth',
					block: 'nearest',
				});
			});
		}
	});
});
